import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsEmptyService {
  /**
   * Checks if a value is empty
   * @param value The value to check
   * @returns true if the value is empty, false otherwise
   */
  static isEmpty(value: any): boolean {
    // Handle null/undefined
    if (value == null) {
      return true;
    }

    // Handle arrays and strings
    if (Array.isArray(value) || typeof value === 'string') {
      return value.length === 0;
    }

    // Handle Set and Map
    if (value instanceof Set || value instanceof Map) {
      return value.size === 0;
    }

    // Handle Date objects - always considered non-empty
    if (value instanceof Date) {
      return false;
    }

    // Handle plain objects
    if (typeof value === 'object') {
      return Object.keys(value).length === 0;
    }

    // All other values are considered non-empty
    return false;
  }
}
